export default "__VITE_ASSET__BcrnLpAs__"